import React from 'react';

interface TaskAuthorIconProps {
    fill?: string;
}

export const TaskAuthorIcon = ({ fill = '#818998' }: TaskAuthorIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
        >
            <path
                d="M11.9997 16.0001H10.6664V12.6382C10.6658 12.1156 10.458 11.6145 10.0884 11.2449C9.71884 10.8753 9.21774 10.6675 8.69509 10.667H3.30457C2.78192 10.6675 2.28083 10.8753 1.91125 11.2449C1.54168 11.6145 1.33383 12.1156 1.3333 12.6382V16.0001H0V12.6382C0.00105852 11.7621 0.349558 10.9222 0.969056 10.3027C1.58855 9.68322 2.42847 9.33472 3.30457 9.33366H8.69509C9.57119 9.33472 10.4111 9.68322 11.0306 10.3027C11.6501 10.9222 11.9986 11.7621 11.9997 12.6382V16.0001Z"
                fill={fill}
            />
            <path
                d="M5.99983 7.99972C5.20873 7.99972 4.43539 7.76513 3.77761 7.32561C3.11983 6.8861 2.60716 6.2614 2.30441 5.53052C2.00167 4.79964 1.92246 3.99539 2.0768 3.21949C2.23113 2.44359 2.61209 1.73088 3.17148 1.17148C3.73088 0.612086 4.44359 0.231134 5.21949 0.0767975C5.99539 -0.0775391 6.79964 0.00167206 7.53052 0.304414C8.2614 0.607156 8.8861 1.11983 9.32561 1.77761C9.76513 2.43539 9.99972 3.20873 9.99972 3.99983C9.99866 5.06034 9.5769 6.07711 8.82701 6.82701C8.07711 7.5769 7.06034 7.99866 5.99983 7.99972ZM5.99983 1.33324C5.47243 1.33324 4.95687 1.48963 4.51835 1.78264C4.07983 2.07565 3.73805 2.49211 3.53622 2.97937C3.33439 3.46662 3.28158 4.00279 3.38447 4.52006C3.48737 5.03732 3.74133 5.51247 4.11426 5.88539C4.48719 6.25832 4.96233 6.51229 5.4796 6.61518C5.99687 6.71807 6.53303 6.66527 7.02029 6.46344C7.50755 6.26161 7.92401 5.91983 8.21702 5.48131C8.51003 5.04279 8.66642 4.52723 8.66642 3.99983C8.66642 3.2926 8.38548 2.61435 7.8854 2.11426C7.38531 1.61418 6.70705 1.33324 5.99983 1.33324Z"
                fill={fill}
            />
        </svg>
    );
};
